import React from 'react';
import { Cta } from '../Cta';
import { Reveal } from '../Reveal';
import { useScore } from '../ScoreContext';
import { trackProofScoreCtaClick } from '../../lib/analytics';

/**
 * Compact bridge after the author-context proof — capitalizes on the
 * completed sequence without becoming another large section.
 */
export function ProofScoreCta() {
  const {
    openDiagnostic,
    answeredCount
  } = useScore();
  const label = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  const handleClick = () => {
    trackProofScoreCtaClick();
    openDiagnostic();
  };
  return <section className="bg-paper px-6 py-14 text-center md:px-10 md:py-16" data-id="element-868" data-mp="e6djwenrd95">
      <div className="mx-auto max-w-2xl" data-id="element-869" data-mp="56zkmqxlmxoe">
        <Reveal data-id="element-870" data-mp="33w7ucv23rybg">
          <h2 className="mx-auto max-w-xl font-serif text-2xl leading-snug text-navy md:text-3xl" data-id="element-871" data-mp="33whomuu6krmy">
            <span className="block" data-id="element-872" data-mp="38usvqxt3co1h">What happens after someone reads</span>
            <span className="block" data-id="element-873" data-mp="38sya1h9zwrwc">your book now?</span>
          </h2>
          <div className="mt-7 flex justify-center" data-id="element-874" data-mp="2l7x3e3p0b02b">
            <Cta variant="primary" showArrow onClick={handleClick} className="px-8 py-3.5 text-base md:px-10 md:py-4 md:text-lg" data-id="element-875" data-mp="2h6bn08d9k3nd">
              {label}
            </Cta>
          </div>
        </Reveal>
      </div>
    </section>;
}